import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

function monthItems() {
  const now = new Date();
  const items = [];
  for (let i = -12; i <= 2; i++) {
    const d = new Date(now.getFullYear(), now.getMonth() + i, 1);
    const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
    const label = d.toLocaleString("en-US", { month: "short", year: "numeric" });
    items.push(
      <SelectItem key={key} value={key}>
        {label}
        {i === 0 ? "  ·  This month" : ""}
      </SelectItem>
    );
  }
  return items.reverse();
}

export default function InvoiceFiltersBar({ isAdmin, filters, setFilters, filterEntities }) {
  return (
    <div
      className="border border-line bg-card p-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-6 gap-3"
      data-testid="invoice-filters"
    >
      {isAdmin && (
        <div>
          <Label className="eyebrow">Business Unit</Label>
          <Select
            value={filters.entity_type}
            onValueChange={(v) => setFilters({ ...filters, entity_type: v, entity_id: "all" })}
          >
            <SelectTrigger className="rounded-sm mt-1" data-testid="filter-entity-type">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All</SelectItem>
              <SelectItem value="client">Clients</SelectItem>
              <SelectItem value="partner">Partners</SelectItem>
            </SelectContent>
          </Select>
        </div>
      )}
      <div>
        <Label className="eyebrow">Status</Label>
        <Select value={filters.status} onValueChange={(v) => setFilters({ ...filters, status: v })}>
          <SelectTrigger className="rounded-sm mt-1" data-testid="filter-status">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All</SelectItem>
            <SelectItem value="unpaid">Unpaid</SelectItem>
            <SelectItem value="partial">Partially paid</SelectItem>
            <SelectItem value="overdue">Overdue</SelectItem>
            <SelectItem value="paid">Paid</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div>
        <Label className="eyebrow">Invoice Month</Label>
        <Select
          value={filters.month || "all"}
          onValueChange={(v) => setFilters({ ...filters, month: v === "all" ? "" : v })}
        >
          <SelectTrigger className="rounded-sm mt-1" data-testid="filter-month">
            <SelectValue placeholder="All months" />
          </SelectTrigger>
          <SelectContent className="max-h-72">
            <SelectItem value="all">All months</SelectItem>
            {monthItems()}
          </SelectContent>
        </Select>
        <div className="text-[10px] text-ink-2 mt-1">Filters by invoice date</div>
      </div>
      <div>
        <Label className="eyebrow">Entity</Label>
        <Select
          value={filters.entity_id}
          onValueChange={(v) => setFilters({ ...filters, entity_id: v })}
        >
          <SelectTrigger className="rounded-sm mt-1" data-testid="filter-entity">
            <SelectValue placeholder="All entities" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All entities</SelectItem>
            {filterEntities.map((e) => (
              <SelectItem key={e.id} value={e.id}>
                {e.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div>
        <Label className="eyebrow">Paid In</Label>
        <Select
          value={filters.paid_in || "all"}
          onValueChange={(v) => setFilters({ ...filters, paid_in: v })}
        >
          <SelectTrigger className="rounded-sm mt-1" data-testid="filter-paid-in">
            <SelectValue placeholder="Any time" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Any time</SelectItem>
            <SelectItem value="week">This week</SelectItem>
            <SelectItem value="month">This month</SelectItem>
            <SelectItem value="7d">Last 7 days</SelectItem>
            <SelectItem value="30d">Last 30 days</SelectItem>
          </SelectContent>
        </Select>
        <div className="text-[10px] text-ink-2 mt-1">Filters by payment date</div>
      </div>
      <div>
        <Label className="eyebrow">Invoice #</Label>
        <Input
          className="rounded-sm mt-1"
          value={filters.q}
          placeholder="Search"
          onChange={(e) => setFilters({ ...filters, q: e.target.value })}
          data-testid="filter-search"
        />
      </div>
    </div>
  );
}
